<template>
  <div class="accountBox">
    <div v-if="authority">
      <div class="add-account">
        <a-button 
          v-track-click="{ trackName: '新建账号' }"
          v-auth="$_ButtonPermission.ACCOUNT_ADDACCOUNT"
          class="accountStyle"
          type="primary"
          @click="toAddAccount"
        >新建账号</a-button>
      </div>
      <div class="account-contanier">
        <div class="search-pane">
          <pro-search 
          :fileds="SearchFiled"
          :form="form"
          @search="handleSearch"
          @reset="handleReset"
          >
            <template slot="serviceProvider">
              <serviceSelect ref="serviceSelect" :only-select="false"  @change="handleChange"></serviceSelect>
            </template>
          </pro-search>
        </div>
        <div>
          <a-table
            :columns="tableListColumns"
            :data-source="List"
            :scroll="{ x: 'calc(700px + 50%)'}"
            :pagination="pagination"
            class="table-sigle"
            row-key="id"
            @change="tableChange"
          >
            <template :slot="'channel'" slot-scope="text">
              {{Code[text]}}
            </template>
            <template :slot="'showCustomers'" slot-scope="text">
              <a-tooltip>
                <template slot="title">{{text}}</template>
                <div class="ellipsis">
                  {{ text }}
                </div>
              </a-tooltip>
            </template>
            <template :slot="'projectList'" slot-scope="text,record">
              <div v-if="record.projectList && record.projectList.length==1">{{ record.projectList[0].projectName }}</div>
              <div v-if="record.projectList && record.projectList.length>1">
                <a-tooltip>
                  <template slot="title">
                    {{ record.projectList.map(t=>t.projectName).join('、') }}
                  </template>
                  <div class="ellipsis">
                    {{ record.projectList[0].projectName }}等{{ record.projectList.length }}个项目
                  </div>
                </a-tooltip>
              </div>
              <div v-if="!record.projectList||!record.projectList.length">全部项目</div>
            </template>
            <template :slot="'caozuo'" slot-scope="text, record">
              <span
                v-if="isCurrentUser(record.accountId)"
                v-track-click="{ trackName: '账号管理-修改' }"
                v-auth="$_ButtonPermission.ACCOUNT_EDIT"
                class="textBtn"
                @click="onEdit(record)"
              >修改</span>
              <span
                v-if="isCurrentUser(record.accountId)"
                v-auth="$_ButtonPermission.ACCOUNT_DELETE"
                v-track-click="{ trackName: '账号管理-删除' }"
                class="textBtn"
                @click="onDelete(record)"
              >删除</span>
              <span
                v-if="isCurrentUser(record.accountId)"
                v-auth="$_ButtonPermission.ACCOUNT_RESETPASSWORD"
                v-track-click="{ trackName: '账号管理-重置密码' }"
                class="textBtn"
                @click="onReset(record)"
              >重置密码</span>
              <span
                v-track-click="{ trackName: '账号管理-消息推送' }"
                class="textBtn"
                @click="onMessagePush(record)"
              >消息推送</span>
              <span
                v-if="isCurrentUser(record.accountId)"
                v-track-click="{ trackName: '账号管理-项目授权' }"
                v-auth="$_ButtonPermission.ACCOUNT_EDIT"
                class="textBtn"
                @click="projectAuth(record)"
              >项目授权</span>
            </template>
          </a-table>
        </div>
      </div>
      <a-modal
        v-model="visible"
        width="600px"
        :mask-closable="false"
        :footer="null"
        title="提示"
        centered
        @cancel="onhidden"
      >
          <div>
              {{modelText}}
          </div>
        <a-row class="btnBox">
          <a-col :span="8" :offset="16">
            <a-button @click="onhidden">取消</a-button>
            <a-button type="primary" @click="onSubmit">提交</a-button>
          </a-col>
        </a-row>
      </a-modal>
    </div>
    <div v-else class="noAuthority">
      <!-- 暂未对个人货主开放，敬请期待 -->
      暂未开放，敬请期待
    </div>
    <message-push
      ref="messageDom"
    />
    <projectAuthDialog ref="projectAuthDialog" />
  </div>
</template>

<script>
import moment from "moment";
import ProSearch from '@/components/TableSearch/index.vue'
import serviceSelect from '@/components/selectCarrier/serviceSelect.vue'
import { getAccount, resetAccount, deleteAccount } from './api'
import MessagePush from './components/MessagePush.vue'
import {SearchFiled} from './constant'
import projectAuthDialog from './components/projectAuthDialog.vue'

const ENABLE = 1; // 启用
const Code = {
  WEB_CREATE: '货主端创建',
  WEB_PLATFORM_CREATE: '货主端创建',
  'WEB_OTMS2.0_CREATE': 'OTMS创建',
  SYSTEM: '系统创建',
  CUSTOMER: '货主端创建',
  PLATFORM: '平台创建',
  WEB_REGISTER: '货主端创建',
  MINI_APP_REGISTER: '小程序创建',
  customer_app_ios: '货主APP创建',
  customer_app_android: '货主APP创建',
  VERSION2:'系统创建'
};

export default {
  name: "Account",
  components: {
    MessagePush,
    ProSearch,
    projectAuthDialog,
    serviceSelect,
  },
  props: {},
  data() {
    return {
      pageSize: 10,
      ENABLE,
      Code,
      SearchFiled,
      authority: true,
      tableListColumns: [
        {
          title: "账号",
          dataIndex: "account",
          key: "account",
          width: 160,
          scopedSlots: { customRender: "account" },
        },
        {
          title: "姓名",
          dataIndex: "realName",
          key: "realName",
          width: 160,
          scopedSlots: { customRender: "realName" },
        },
        {
          title: "手机号",
          dataIndex: "mobile",
          key: "mobile",
          width: 160,
          scopedSlots: { customRender: "mobile" },
        },
        {
          title: "服务商",
          dataIndex: "showCustomers",
          key: "showCustomers",
          width: 260,
          scopedSlots: { customRender: "showCustomers" },
        },
        {
          title: "负责项目",
          dataIndex: "负责项目",
          key: "projectList",
          width: 260,
          scopedSlots: { customRender: "projectList" },
        },
        {
          title: "来源",
          dataIndex: "channel",
          key: "channel",
          width: 160,
          scopedSlots: { customRender: "channel" },
        },
        {
          title: "创建时间",
          dataIndex: "createTime",
          key: "createTime",
          width: 160,
          scopedSlots: { customRender: "createTime" },
        },
        {
          title: "操作",
          dataIndex: "caozuo",
          key: "caozuo",
          width: 320,
          scopedSlots: { customRender: "caozuo" },
          fixed:'right',
        },
      ],
      List: [
      ],
      pagination: {
        current: 1,
        total: 0,
        defaultPageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "30", "40", "50"],
        onShowSizeChange: (current, pageSize) => {
          this.pageSize = pageSize;
        },
        showQuickJumper: true,
        showTotal: (total) => `共 ${total} 条`,
      },
      visible: false,
      form: {
        account: "",
        name: "",
        mobiles: ''
      },
      modelType: 0,
      modelText: '',
      modelData: {},
      accountData: {},
      isEnterprise: false,
      chooseCustomerId: '',
    };
  },
  computed: {
    isCurrentUser(){
     return (id)=>!!(this.accountId!==id)
    },
  },
  created() {
    const {accountId,creditCode}=this.$store.state.user
    this.isEnterprise = !!creditCode
    // 不是企业
    if(!this.isEnterprise) {
      this.SearchFiled=this.SearchFiled.filter(item=>item.name!=='serviceProvider')
    }else{
      this.tableListColumns=this.tableListColumns.filter(t=>t.key!=='projectList')
    }
    this.accountData = JSON.parse(localStorage.getItem('accountData'));
    this.getList()
    this.accountId=accountId
  },
  mounted() {},
  methods: {
    // 切换服务商
    handleChange(value) {
      this.chooseCustomerId = value.id
      // this.form.carrierTenantName=value.carrierTenantName
      // this.form.customerCode=value.customerCode
      this.getList();
    },
    onMessagePush(data){
      this.$refs.messageDom.show(data.accountId)
    },
    filterData(data, value) {
      return data === value ? null : data;
    },
    handleSearch(form){
      this.pagination.current=1
      this.form={
        ...form,
      }
      this.getList();
    },
    getList() {
      const {customerId,creditCode,customers}=this.$store.state.user
      const data = {
        account: this.filterData(this.form.account, ""),
        mobile: this.filterData(this.form.mobiles, ""),
        realNameLike: this.filterData(this.form.name, ""),
        status: 'ENABLED',
        groupByAccountId: true,
        // carrierTenantName: this.filterData(this.form.carrierTenantName, ""),
        // customerCode: this.filterData(this.form.customerCode, ""),
      };
      if(creditCode){
        // data.creditCode=creditCode
        // data.accountId=accountId
        //  data.customerId=customerId
        if (this.chooseCustomerId) {
          data.customerIds = [this.chooseCustomerId]
        } else {
          data.customerIds = customers.map(item => item.customerId);
        }
      }else{
        data.customerIds = [customerId]
      }
      const params = {
        size: this.pageSize,
        page: this.pagination.current,
      };
      getAccount(data, params).then((res) => {
        this.List = res.records.map((e) => {
          return {
            ...e,
            showCustomers: this.getCustomers(e),
            createTime: moment(e.createTime).format('YYYY-MM-DD HH:mm:ss')
          }
        })
        this.pagination.total = res.total
      })
    },
    getCustomers(record) {
      const customers = [];
      (record.customers || []).forEach(item => {
        if (!customers.includes(item.ownerTenantName)) {
          customers.push(item.ownerTenantName)
        }
      });
      return customers.join(',')
    },
    tableChange(pagination) {
      this.pagination = {
        ...this.pagination,
        current: pagination.current,
      };
      this.getList();
    },
    onhidden() {
      this.visible = false;
    },
    onSubmit(){
      this.visible = false;
      if (this.modelType === 1){
        resetAccount({
          id: this.modelData.id
        }).then(() => {
          this.$message.success('密码重置成功')
        })
      }
      if (this.modelType === 0){
        const {customerId, customers}=this.$store.state.user
        const data={ 
          accountId: this.modelData.accountId,
          identityType: 'CUSTOMER',
          customerId,
          // creditCode,
          customerIds: (customers || []).map(item => item.customerId)
        }
        deleteAccount(data).then(() => {
          this.$message.success('账号删除成功')
          this.getList()
        })
      }
    },
    createProject() {
      this.visible = true;
    },
    onEdit(record) {
      const {
        showCustomers,
        accountOrgExt,
        createTime,
        channel,
        ...data
      } = record
      this.$router.push({
        path: 'addaccountEdit',
        query: { 
          ...data,
          customers: JSON.stringify(data.customers)
        }
      })
    },
    handleReset() {
      this.form.account = ""
      this.form.name = ""
      this.form.mobiles = ''
      this.form.carrierTenantName = ""
      this.form.customerCode = ""
      this.chooseCustomerId = ''
      this.pagination.current = 1
      setTimeout(()=>{
        const {creditCode}=this.$store.state.user
        if(creditCode&&this.$refs.serviceSelect){
          this.$refs.serviceSelect.handleReset()
        }
      },100)
      this.getList()
    },
    onDelete(data) {
      this.visible = true;
      this.modelType = 0
      this.modelData = data
      this.modelText = `确定删除账号[${data.account}]?`
    },
    onReset(data) {
      this.visible = true;
      this.modelType = 1
      this.modelData = data
      this.modelText = `确定重置账号[${data.account}]的密码?`
    },
    toAddAccount() {
      this.$router.push('addaccount')
    },
    projectAuth(data){
      this.$refs.projectAuthDialog.show({...data})
    },
  },
};
</script>

<style lang="less" scoped>
.accountBox{
  border-radius: 6px;
  box-sizing: border-box;
  .account-contanier {
    padding: 20px 30px 15px;
    background: #fff;
  }
  .add-account {
    text-align: right;
    margin-bottom: 20px;
  }
}
.form-row {
  .formTitle{
    text-align: right;
    padding-right: 6px;
    width: 100%;
    display: inline-block;
    font-size: 0.8rem;
    line-height: 32px;
  }
}
.form-btns {
  display: flex;
  justify-content: flex-end;
  margin-right: 0;
  margin-top: 20px;
  .form-btn {
  margin-left: 20px;
}
}

.tablebox {
  margin-bottom: 10px;
  margin-top: 20px;
  position: relative;
  /deep/ .ant-table {
    .ant-table-thead,
    .ant-table-scroll {
      background-color: #f5f5f5;
    }
    .ant-table-column-title {
      font-weight: bold;
    }
  }
}
.goodsSelectStyle {
  margin-top: 4px;
}
.textBtn {
  text-decoration: underline;
  color: #06b880;
  margin-right: 15px;
  &:hover {
    cursor: pointer;
  }
}
.tr {
  text-align: right;
}
.btnBox {
  text-align: right;
  button {
    margin-left: 15px;
  }
}
.noAuthority{
  text-align: center;
  color: #ccc;
  height: calc(100vh - 200px);
  line-height: calc(100vh - 200px);
}
</style>
